export default __webpack_public_path__ + "static/5_23-6f2d58bf6982212637698f1e62e923f9.png";